import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5a1d6c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fs-5 mb-0" }
const _hoisted_2 = {
  key: 0,
  class: "fs-6 fst-italic"
}
const _hoisted_3 = { class: "buttons d-flex justify-content-end align-items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "restart_alt", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm btn-icon btn-primary ms-2",
  type: "submit"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "search")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_base_card_header = _resolveComponent("base-card-header")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputRadioBoolean = _resolveComponent("InputRadioBoolean")!
  const _component_SelectBrands = _resolveComponent("SelectBrands")!
  const _component_base_card_body = _resolveComponent("base-card-body")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_dp_form = _resolveComponent("dp-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertError2, {
      error: _ctx.criteriaUI.getError()
    }, null, 8, ["error"]),
    _createVNode(_component_BaseSpinner, {
      spin: _ctx.criteriaUI.isNotReady()
    }, null, 8, ["spin"]),
    (_ctx.criteriaUI.isReady())
      ? (_openBlock(), _createBlock(_component_dp_form, {
          key: 0,
          as: "form",
          novalidate: "",
          onSubmit: _ctx.submitData
        }, {
          default: _withCtx(({ errors }) => [
            _createVNode(_component_base_card, {
              class: _normalizeClass(["criteria", {'is-changed': _ctx.productsCriteriaIsChanged}])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_card_header, null, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", _hoisted_1, [
                      _createTextVNode(_toDisplayString(_ctx.$t('filters')) + " ", 1),
                      (_ctx.productsCriteriaIsChanged)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(" + _toDisplayString(_ctx.$t('updated')) + ")", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-icon btn-danger",
                        type: "reset",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearCriteria && _ctx.clearCriteria(...args)), ["prevent"]))
                      }, _hoisted_5),
                      _hoisted_6
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_base_card_body, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputNumber, {
                      modelValue: _ctx.productsCriteria.filter_cnk_code,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.productsCriteria.filter_cnk_code) = $event)),
                      label: _ctx.$t('cnkCode'),
                      name: "filter_cnk_code",
                      class: "mt-1",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors"]),
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.productsCriteria.search_keyword,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.productsCriteria.search_keyword) = $event)),
                      label: _ctx.$t('keyword'),
                      name: "search_keyword",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors"]),
                    _createVNode(_component_InputRadioBoolean, {
                      modelValue: _ctx.productsCriteria.filter_is_image_available,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.productsCriteria.filter_is_image_available) = $event)),
                      label: _ctx.$t('imageAvailable'),
                      name: "is_image_available",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors"]),
                    _createVNode(_component_InputRadioBoolean, {
                      modelValue: _ctx.productsCriteria.filter_is_commercially_available,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.productsCriteria.filter_is_commercially_available) = $event)),
                      label: _ctx.$t('commerciallyAvailable'),
                      name: "is_commercially_available",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors"]),
                    _createVNode(_component_SelectBrands, {
                      "selected-brand-codes": _ctx.productsCriteria.filter_brand_code ? [_ctx.productsCriteria.filter_brand_code] : [],
                      "catalog-customer-code": _ctx.catalogCustomerCode,
                      class: _normalizeClass([{'brand-selected': _ctx.productsCriteria.filter_brand_code}, "mb-3"]),
                      "btn-class": "btn btn-icon btn-outline-primary",
                      "is-pim-labo": "",
                      onAddBrand: _ctx.setBrandCode,
                      onRemoveBrand: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setBrandCode(undefined)))
                    }, null, 8, ["selected-brand-codes", "catalog-customer-code", "class", "onAddBrand"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["class"])
          ]),
          _: 1
        }, 8, ["onSubmit"]))
      : _createCommentVNode("", true)
  ], 64))
}